import DokanListIcons from '../icon/DokanListIcons';

function DokanNotification() {
    return (
        <>
            <button className="mx-6 text-secondary-600 focus:outline-none" type="button">
                <DokanListIcons icon="notification_bell" size={18} />
            </button>
        </>
    );
}

export default DokanNotification;
